import { Outlet } from 'react-router-dom'
import { Scrollbars } from 'react-custom-scrollbars'

const MainRoute = () => {
  return (
    <Scrollbars
      autoHide
      renderTrackHorizontal={() => <div></div>}
      // style={{ height: 'calc(100vh - 0px)' }}
      style={{ height: '100%', backgroundColor: '#F6F8FB', borderRadius: '12px' }}
    >
      <div style={{ paddingLeft: 10, paddingRight: 10 }}>
        <Outlet />
      </div>
    </Scrollbars>
  )
}

export default MainRoute
